import {AfterContentChecked, ChangeDetectorRef, Component, HostListener, OnInit} from '@angular/core';
import {LoaderProvider} from './utils/providers/loader-provider';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterContentChecked {
  title = 'vs-frontend-cms';
  isLoaded: Observable<boolean>;
  isDesktop = true;

  constructor(
    private loader: LoaderProvider,
    private cdr: ChangeDetectorRef,
    ) {
  }
  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): any {
    this.isDesktop = event.target.innerWidth > 992;
  }

  ngOnInit() {
    this.loader.getIsLoadingValue()
      .subscribe(res => {
        this.isLoaded = res;
      });
  }


}
